<template>
  <div class="main-container">
    <breadcrumb
    main_step_name="Payroll"
          sub_step_name="Reports"
          step_name="Salary Register"
          @goToMainStep="routeToMainStep"
          @goToSubStep="routeToSubStep"
    />

    <section class="main-content-section">
      <div class="filters">
        <tl-select label="Financial year" labelText="name" :options="financialYearList"></tl-select>
        <tl-select label="Month" :multiple="true" labelText="name" :options="monthList"></tl-select>
        <tl-select label="Paygroups" labelText="name" :options="paygroupList"></tl-select>
        <tl-select label="Employee Status" labelText="name" :options="employeeStatusList"></tl-select>
        <tl-select
          label="Criteria"
          labelText="name"
          :options="criteriaList"
          @change="onSelectCriteria($event)"
        ></tl-select>
        <tl-select
          v-if="isCriteriaSelected"
          label="Sub-Criteria"
          labelText="name"
          :options="subCriteriaList"
        ></tl-select>
        <div class="margintop-20">
          <btn text="Apply Filters" type="secondary" class="filter-btn" />
        </div>
      </div>
      <div class="threeColumnGrid margintop-40 mb-10">
        <search-dropdown :employeeData="employeeTableData" @empselected="(emp)=>selectedEmp(emp)"></search-dropdown>
      </div>
      <data-table
        :columns="tableColumns"
        :tableData="employeeTableData"
        :checkbox="true"
        :showinrow="false"
      ></data-table>
      <bottom-action-container class="position-fixed">
        <btn-grp slot="end">
          <btn text="Cancel" type="secondary" class></btn>
          <btn text="Download Register" type="primary" class @click="DownloadReport"></btn>
        </btn-grp>
      </bottom-action-container>
    </section>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
export default {
  name: "SalaryRegister",
  components: {
    SearchDropdown
  },
  data() {
    return {
      isCriteriaSelected: false,
      tableColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "emailId"
        },
        {
          label: "Location",
          key: "location"
        }
      ],
      financialYearList: [
        {
          name: "2017-2018",
          value: "2017-2018"
        },
        {
          name: "2018-2019",
          value: "2018-2019"
        },
        {
          name: "2019-2020",
          value: "2019-2020"
        }
      ],
      monthList: [
        {
          name: "January",
          value: "jan"
        },
        {
          name: "February",
          value: "feb"
        },
        {
          name: "March",
          value: "mar"
        },
        {
          name: "April",
          value: "apr"
        },
        {
          name: "May",
          value: "may"
        },
        {
          name: "June",
          value: "june"
        },
        {
          name: "July",
          value: "juy"
        },
        {
          name: "August",
          value: "aug"
        },
        {
          name: "September",
          value: "sep"
        },
        {
          name: "October",
          value: "oct"
        },
        {
          name: "November",
          value: "nov"
        },
        {
          name: "December",
          value: "dec"
        }
      ],
      paygroupList: [
        {
          name: "All",
          value: "all"
        },
        {
          name: "Paygroup 1",
          value: "paygroup1"
        },
        {
          name: "Paygroup 2",
          value: "paygroup2"
        }
      ],
      employeeStatusList: [
        {
          name: "All",
          value: "all"
        },
        {
          name: "Active",
          value: "active"
        },
        {
          name: "Inactive",
          value: "inactive"
        }
      ],
      criteriaList: [
        {
          name: "All",
          value: "all"
        },
        {
          name: "Business Unit",
          value: "businessUnit"
        },
        {
          name: "Cost center",
          value: "costCenter"
        },
        {
          name: "Department",
          value: "department"
        },
        {
          name: "Designation",
          value: "designation"
        },
        {
          name: "Salary band",
          value: "salaryBand"
        },
        {
          name: "Salary grade",
          value: "salaryGrade"
        }
      ],
      subCriteriaList: [
        {
          name: "All",
          value: "all"
        }
      ],
      employeeTableData: [
        {
          code: "RX1023",
          name: "Salary grade",
          department: "IT",
          emailId: "johndoe@gmail.com",
          location: "Hyderabad"
        }
      ]
    };
  },
  methods: {
    selectedEmp(e) {
      //console.log(e);
    },
    DownloadReport() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/salary_reports`
      });
    },
    onSelectCriteria(e) {
      //console.log(e);
      if (e.value == "all") {
        this.isCriteriaSelected = false;
      } else {
        this.isCriteriaSelected = true;
      }
    },
    routeToMainStep(){},
    routeToSubStep(){}
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.filter-btn {
  min-height: 0px;
  padding: 5px;
  min-width: 100px;
}
</style>
